import React, { useState } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Grid, Box, Card, CardMedia, CardContent } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from '../Components/Header';
import Footer from './Footer';
import sunset from '../images/begin.jpeg'; 
import abstract from '../images/inter2.jpeg'; 
import mountain from '../images/expert.jpeg';
import slidedata1 from '../images/slidedata1.jpeg'
import slidedata2 from '../images/slidedata2.jpeg'
import slidedata3 from '../images/slidedata3.jpeg'
import slidedata4 from '../images/slidedata4.jpeg'
import slidedata5 from '../images/slidedata5.jpeg'
import slidedata6 from '../images/slidedata9.jpeg'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HomeIcon from '@mui/icons-material/Home';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './Arts.css'
const theme = createTheme();

const ArtsPage = () => {
  const [formData, setFormData] = useState({
    studentName: '',
    parentName: '',
    email: '',
    phone: '',
    program: '',
    tentativeStartDate: '',
    schedule: '',
    numberOfClasses: '',
    preferredLanguage: '',
    tentativePreferredTime: '',
    timezone: '',
  });


  const [errors, setErrors] = useState({});

  const Process = [
    1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16
  ];

  const preferredLanguages=[
    'English',
    'Tamil',
    'Telungu'
  ]
  

  const timezones = [
    { label: 'EST (Eastern Standard Time, UTC-5)', value: 'UTC-5' },
    { label: 'CST (Central Standard Time, UTC-6)', value: 'UTC-6' },
    { label: 'MST (Mountain Standard Time, UTC-7)', value: 'UTC-7' },
    { label: 'PST (Pacific Standard Time, UTC-8)', value: 'UTC-8' },
    { label: 'AKST (Alaska Standard Time, UTC-9)', value: 'UTC-9' },
    { label: 'HST (Hawaii Standard Time, UTC-10)', value: 'UTC-10' },
  ];

  const programs = [
    'Sketching',
    'Watercolor Painting',
    'Oil Painting',
    'Digital Art',
  ];

  const schedules = [
    'Weekly',
    'Monthly',
  ];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleDateChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' }); 
  };

  const validateForm = () => {
    let isValid = true;
    let errors = {};

    const requiredFields = {
      studentName: 'Student name is required',
      parentName: 'Parent name is required',
      email: 'Email is required',
      phone: 'Phone number is required',
      tentativeStartDate: 'Start date is required',
      program: 'Program selection is required',
      schedule: 'Schedule is required',
      numberOfClasses: 'Number of classes are required',
      preferredLanguage: 'Language selection is required',
      tentativePreferredTime: 'Time is required',
      timezone: 'Timezone is required',
    };
  errors = {}; 
   isValid = true;

Object.keys(requiredFields).forEach(field => {
  if (!formData[field]) {
    errors[field] = requiredFields[field];
    isValid = false;
  }
});

    

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
      isValid = false;
    }

    const today = new Date().toISOString().split('T')[0];
    if (formData.TentativestartDate && formData.TentativestartDate < today) {
      errors.TentaivestartDate = 'Start date cannot be in the past';
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Combine time and timezone
      const combinedTime = `${formData.tentativePreferredTime} ${formData.timezone}`;

      const payload = {
        ...formData,
        tentativePreferredTime: combinedTime,
        timezone: undefined, // drop separate field
      };

      try {
        const response = await fetch('https://globalsgtech.com/api/api/student-form', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (response.ok) {
          console.log(result.message);
          alert('Thank you for registering! Our team will review your details and get back to you soon.');
          setFormData({
            studentName: '',
            parentName: '',
            email: '',
            phone: '',
            program: '',
            tentativeStartDate: '',
            schedule: '',
            numberOfClasses: '',
            preferredLanguage: '',
            tentativePreferredTime: '',
            timezone: '',
          });
        } else {
          console.error(result.message);
          alert('Error submitting form');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('Error submitting form');
      }
    }
  };

  return (
    <><div>
      <Header />
      <section className="arts-header">
        <div className="header-content">
          <h1>Explore the World of Arts</h1>
          <p>Unleash your child's creativity! Register for our exciting kids' art classes.</p>
          <a href="#register" className="btn-cta">Register Now</a>
        </div>
      </section>

      <section className="art-categories" >
      <Box my={5}>
  <Typography
    variant="h5"
    gutterBottom
    className="header"
    style={{ color: '#088395', fontWeight: 'bold' }}
  >
    Art Gallery
  </Typography>
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6} md={4}>
      <Card className="card-animation">
        <CardMedia
          component="img"
          alt="Beginners"
          image={sunset}
          title="Beginners"
          style={{ height: 'auto', maxHeight: '300px', objectFit: 'cover' }} 
        />
        <CardContent style={{ height: 'auto' }}> 
          <Typography variant="h6" style={{ color: '#071952', fontSize: '1.2rem' }}>
            <b>Beginners</b>
          </Typography>
          <Typography variant="body2" style={{ fontSize: '0.9rem' }}>
            Discover the basics of art with simple drawing techniques, fundamental color theory, and an introduction to various art tools. Learn to balance compositions, practice shading, and explore different art styles to build a solid foundation.
          </Typography>
        </CardContent>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card className="card-animation">
        <CardMedia
          component="img"
          alt="Intermediate"
          image={abstract}
          title="Intermediate"
          style={{ height: 'auto', maxHeight: '300px', objectFit: 'cover' }} 
        />
        <CardContent style={{ height: 'auto' }}> 
          <Typography variant="h6" style={{ color: '#071952', fontSize: '1.2rem' }}>
            <b>Intermediate</b>
          </Typography>
          <Typography variant="body2" style={{ fontSize: '0.9rem' }}>
            Enhance your skills with advanced drawing techniques, in-depth color theory, and a variety of art media. Focus on complex compositions, master shading, and develop your unique artistic style while gaining a deeper understanding of art history.
          </Typography>
        </CardContent>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card className="card-animation">
        <CardMedia
          component="img"
          alt="Experts"
          image={mountain}
          title="Experts"
          style={{ height: 'auto', maxHeight: '300px', objectFit: 'cover' }} 
        />
        <CardContent style={{ height: 'auto' }}> 
          <Typography variant="h6" style={{ color: '#071952', fontSize: '1.2rem' }}>
            <b>Experts</b>
          </Typography>
          <Typography variant="body2" style={{ fontSize: '0.9rem' }}>
            Master drawing, painting, and color application. Explore advanced techniques, create innovative compositions, and refine your personal style. Engage in contemporary art discussions and contribute to the art world with impactful projects
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>

<div className="container" id='register'>
          {/* <Container maxWidth="md"> */}
            {/* <Box my={5}> */}
              <Typography variant="h4" gutterBottom className="header" style={{ color: '#088395', fontWeight: 'bold' }}>
                Arts Drawing Program Registration
              </Typography>
              <Typography variant="body1" gutterBottom>
                Join our arts drawing program to unleash your creativity. We offer a range of programs including sketching, watercolor painting, oil painting, and digital art.<br/> Our experienced teachers are dedicated to providing personalized instruction to help you achieve your artistic goals.
              </Typography>
              {/* <Typography variant="body1" gutterBottom>
                Explore some of the amazing artwork created by our students and get inspired to create your own masterpieces!
              </Typography> */}
              <Typography variant="h6" gutterBottom style={{ color: '#ff5722', fontWeight: 'bold', marginTop: '24px' }}>
                Special Offer first Art Session Free!
              </Typography>
              <Typography variant="body1" style={{marginLeft:'42px'}}gutterBottom>
                Register now and enjoy your first session at no cost. Don’t miss this opportunity to start your creative journey with us!
              </Typography>
              <div  className="arts-form-container">
              {/* Registration Form */}
        <Box className="form-box">
          <Typography variant="h6" className="form-title">
            <CheckCircleIcon color="success" style={{ marginRight: '8px' }} />
            Your first class is free — no payment required at signup
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Student & Parent */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth label="Student's Name *" name="studentName"
                  value={formData.studentName} onChange={handleChange}
                  error={!!errors.studentName} helperText={errors.studentName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth label="Parent's Name *" name="parentName"
                  value={formData.parentName} onChange={handleChange}
                  error={!!errors.parentName} helperText={errors.parentName}
                />
              </Grid>

              {/* Email & Phone */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth label="Email *" name="email"
                  value={formData.email} onChange={handleChange}
                  error={!!errors.email} helperText={errors.email}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth label="Phone Number *" name="phone"
                  value={formData.phone} onChange={handleChange}
                  error={!!errors.phone} helperText={errors.phone}
                />
              </Grid>

              {/* Program & Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select fullWidth label="Program *" name="program"
                  value={formData.program} onChange={handleChange}
                  error={!!errors.program} helperText={errors.program}
                >
                  {programs.map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="date" fullWidth label="Tentative Start Date *" name="tentativeStartDate"
                  value={formData.tentativeStartDate} onChange={handleChange}
                  error={!!errors.tentativeStartDate} helperText={errors.tentativeStartDate}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Schedule & Classes */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select fullWidth label="Schedule *" name="schedule"
                  value={formData.schedule} onChange={handleChange}
                  error={!!errors.schedule} helperText={errors.schedule}
                >
                  {schedules.map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
              <TextField
  label="Number of Classes *"
  type="number"
  name="numberOfClasses"
  value={formData.numberOfClasses}
  onChange={handleChange}
  inputProps={{ min: 1, max: 16 }}
  fullWidth
  margin="normal"
  error={!!errors.numberOfClasses}
  helperText={errors.numberOfClasses}
/>
                {/* <TextField
                  select fullWidth label="Number of Classes *" name="numberOfClasses"
                  value={formData.numberOfClasses} onChange={handleChange}
                  error={!!errors.numberOfClasses} helperText={errors.numberOfClasses}
                >
                  {numberOfClasses.map((num) => (
                    <MenuItem key={num} value={num}>{num}</MenuItem>
                  ))}
                </TextField> */}
              </Grid>

              {/* Language & Time */}
              <Grid item xs={12} sm={6}>
                <TextField
                  select fullWidth label="Preferred Language *" name="preferredLanguage"
                  value={formData.preferredLanguage} onChange={handleChange}
                  error={!!errors.preferredLanguage} helperText={errors.preferredLanguage}
                >
                  {preferredLanguages.map((lang) => (
                    <MenuItem key={lang} value={lang}>{lang}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  type="time" fullWidth label="Preferred Time *" name="tentativePreferredTime"
                  value={formData.tentativePreferredTime} onChange={handleChange}
                  error={!!errors.tentativePreferredTime} helperText={errors.tentativePreferredTime}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select fullWidth label="Timezone *" name="timezone"
                  value={formData.timezone} onChange={handleChange}
                  error={!!errors.timezone} helperText={errors.timezone}
                >
                  {timezones.map((tz) => (
                    <MenuItem key={tz.value} value={tz.value}>{tz.label}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Submit */}
              <Grid item xs={12}>
                <Button type="submit" variant="contained" className="register-btn" fullWidth>
                  REGISTER
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </div>
      </div>
            <section className="art-gallery">
      <Box my={5} className="links-container">
              <Typography variant="h5" gutterBottom className="header" style={{color:'#088395',fontWeight:'bold'}}>
                Inspirational Art Quotes and Drawing Links
              </Typography>
              <div className="quotes-container">
          <blockquote style={{backgroundColor:'antiquewhite'}}>
            "Art enables us to find ourselves and lose ourselves at the same time." — Thomas Merton
          </blockquote>
          <blockquote style={{backgroundColor:'antiquewhite'}}>
            "The purpose of art is washing the dust of daily life off our souls." — Pablo Picasso
          </blockquote>
          <blockquote style={{backgroundColor:'antiquewhite'}}>
            "Creativity takes courage." — Henri Matisse
          </blockquote>
        </div>
              <ul className="links-list">
                <li><a href="https://www.google.com/search?q=sketching+art&tbm=isch" target="_blank" rel="noopener noreferrer">Sketching Art</a></li>
                <li><a href="https://www.google.com/search?q=watercolor+painting&tbm=isch" target="_blank" rel="noopener noreferrer">Watercolor Painting</a></li>
                <li><a href="https://www.google.com/search?q=oil+painting&tbm=isch" target="_blank" rel="noopener noreferrer">Oil Painting</a></li>
                <li><a href="https://www.google.com/search?q=digital+art&tbm=isch" target="_blank" rel="noopener noreferrer">Digital Art</a></li>
              </ul>
            </Box>
      </section>
</section>
</div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className='contact-info'> 
                
                {/* Contact Us Section */}
                <div className='contact-us-data'> {/* Add marginRight to shift left */}
                    <Box
                        sx={{
                            padding: 2,
                            backgroundColor: 'aliceblue',
                            height: 'auto',
                        }}
                    >
                        <Typography variant="h6" gutterBottom style={{ color: '#088395', fontWeight: 'bold' }}>
                            Contact Us
                        </Typography>
                        <Typography variant="body1" component="div">
                            <h5>Have any questions? Feel free to Contact us at Anytime.</h5>
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '25px' }}>
                            <WhatsAppIcon style={{ marginLeft: '10px', color: '#039dfc' }} />
                            <span style={{ color: '#039dfc', fontWeight: 'bold', marginLeft: '10px' }}>
                                Contact Number: <a href="https://wa.me/918870944351" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#039dfc' }}>+91-8870944351</a>
                            </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '15px', marginTop: '30px' }}>
                            <HomeIcon style={{ marginLeft: '10px', color: '#039dfc' }} />
                            <span style={{ color: '#039dfc', fontWeight: '400', marginLeft: '10px' }}>
                                US: <a href="https://wa.me/16468649094" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#039dfc' }}>+1-646-864-9094</a>
                            </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '15px', marginTop: '10px' }}>
                            <HomeIcon style={{ marginLeft: '10px', color: '#039dfc' }} />
                            <span style={{ color: '#039dfc', fontWeight: '400', marginLeft: '10px' }}>
                                Chennai: <a href="https://wa.me/918870944351" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#039dfc' }}>+91-8870944351</a>
                            </span>
                        </div>
                        <Button
                            variant="contained"
                            color="success"
                            href="https://wa.me/918870944351"
                            target="_blank"
                            rel="noopener noreferrer"
                            fullWidth
                            style={{ marginTop: '70px', backgroundColor: '#039dfc' }}
                        >
                            Chat on WhatsApp
                        </Button>
                    </Box>
                </div>

                {/* Art Section */}
                <div className='arts-data'>
                    <Box
                        // sx={{
                        //     padding: 2,
                        //     backgroundColor: '#f5f5f5',
                        //     height: 'auto',
                        // }}
                    >
                        <p>
                            Explore some of the amazing artwork created by our students and get inspired to create your own masterpieces!
                        </p>
                        {/* <Typography variant="h6" gutterBottom style={{ color: '#088395', fontWeight: 'bold' }}>
                            Explore Our Children's Art
                        </Typography> */}
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <img src={slidedata1} alt="Art 1" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <img src={slidedata2} alt="Art 2" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <img src={slidedata3} alt="Art 3" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <img src={slidedata4} alt="Art 4" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <img src={slidedata5} alt="Art 5" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <img src={slidedata6} alt="Art 6" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '8px' }} />
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </div>
        </div>
    <Box my={5}>
  <Typography variant="h5" gutterBottom className="header" style={{ color: '#088395', fontWeight: 'bold' }}>
    Drawing Video Tutorials
  </Typography>
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6} md={4}>
      <div className="video-container">
        <iframe
          src="https://www.youtube.com/embed/oBCg0CD-TcQ"
          title="Drawing Tutorial 1"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Grid>
    <Grid item xs={12} sm={6} md={4}>
      <div className="video-container">
        <iframe
          src="https://www.youtube.com/embed/PiJkRJgjFBs"
          title="Drawing Tutorial 2"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Grid>
    <Grid item xs={12} sm={6} md={4}>
      <div className="video-container">
        <iframe
          src="https://www.youtube.com/embed/mzzvCGfKZR8"
          title="Drawing Tutorial 3"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Grid>
  </Grid>
</Box>
    <Footer /></>
  );
};

export default ArtsPage;